module.exports = __webpack_public_path__ + "static/media/roomsC.84daf96a.png";